<template>
  <div id="arrival-time-slot-manage">
    <button type="button" v-on:click="openAddEditModal()">DODAJ</button>
    <table class="arrival-time-slot-table">
      <thead>
        <tr>
          <th>BROJ</th>
          <th>POČETAK</th>
          <th>KRAJ</th>
          <th>DOPUŠTEN BROJ LJUDI</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(arrivalTimeSlot, index) in arrivalTimeSlots" v-bind:key="arrivalTimeSlot.id">
          <td>{{ index + 1 }}.</td>
          <td>{{ arrivalTimeSlot.startOfTimeSlot }}</td>
          <td>{{ arrivalTimeSlot.endOfTimeSlot }}</td>
          <td>{{ arrivalTimeSlot.timeSlotCapacity }}</td>
          <td>
            <button type="button" v-on:click="openAddEditModal(arrivalTimeSlot)">UREDI</button>
          </td>
          <td>
            <button type="button" v-on:click="deleteTimeSlot(arrivalTimeSlot)">IZBRIŠI</button>
          </td>
        </tr>
      </tbody>
    </table>

    <AddEditArrivalTimeSlot
      v-if="modalVisible"
      v-on:save="saveArrivalTimeSlot"
      v-on:cancel="resetArrivalTimeSlot"
      v-bind:arrivalTimeSlot="arrivalTimeSlotForModal"
    />
  </div>
</template>

<script>
import AddEditArrivalTimeSlot from '@/components/admin/arrivalTimeSlots/AddEditArrivalTimeSlot.vue';

export default {
  name: 'ArrivalTimeSlotManage',
  components: {
    AddEditArrivalTimeSlot,
  },
  data() {
    return {
      arrivalTimeSlots: [],
      arrivalTimeSlotForModal: null,
      modalVisible: false,
    };
  },
  created() {
    this.getArrivalTimeSlots();
  },
  methods: {
    getArrivalTimeSlots: function() {
      this.$axios.get(`${this.$API_URL}/arrival-time-slots/for-configuration`).then(response => {
        this.arrivalTimeSlots = response.data;
      });
    },
    saveArrivalTimeSlot: function(arrivalTimeSlot) {
      if (arrivalTimeSlot.id) {
        this.$axios
          .put(`${this.$API_URL}/arrival-time-slots`, arrivalTimeSlot)
          .catch(() => {
            this.axios.get(`${this.$API_URL}/arrival-time-slots?id=${arrivalTimeSlot.id}`).then(response =>
              this.arrivalTimeSlots.splice(
                this.arrivalTimeSlots.findIndex(arrivalTimeSlot => arrivalTimeSlot.id === arrivalTimeSlot.id),
                1,
                response.data,
              ),
            );

            alert('Unešen termin se već poklapa sa postojećim terminom');
          })
          .finally(this.getArrivalTimeSlots);
      } else {
        this.$axios
          .post(`${this.$API_URL}/arrival-time-slots`, arrivalTimeSlot)
          .then(response => {
            arrivalTimeSlot.id = response.data;
            this.arrivalTimeSlots.push(arrivalTimeSlot);
          })
          .catch(error => {
            alert(error.error);
          })
          .finally(this.getArrivalTimeSlots);
      }
      this.modalVisible = false;
    },
    openAddEditModal: function(arrivalTimeSlot) {
      this.arrivalTimeSlotForModal = arrivalTimeSlot ? arrivalTimeSlot : { isAdd: true };
      this.modalVisible = true;
    },
    resetArrivalTimeSlot: function(arrivalTimeSlot) {
      if (arrivalTimeSlot.id) {
        this.$axios
          .get(`${this.$API_URL}/arrival-time-slots/for-configuration/${arrivalTimeSlot.id}`)
          .then(response => {
            this.arrivalTimeSlots.splice(
              this.arrivalTimeSlots.findIndex(arrivalTimeSlot => arrivalTimeSlot.id === arrivalTimeSlot.id),
              1,
              response.data,
            );
          });
      }
      this.modalVisible = false;
    },
    deleteTimeSlot: function(timeSlotToDelete) {
      if (
        confirm(
          `Jeste li sigurni da želite izbrisati time slot: ${timeSlotToDelete.startOfTimeSlot} - ${timeSlotToDelete.endOfTimeSlot}?`,
        )
      ) {
        this.$axios
          .delete(`${this.$API_URL}/arrival-time-slots/${timeSlotToDelete.id}`)
          .then(() => {
            this.arrivalTimeSlots.splice(
              this.arrivalTimeSlots.findIndex(arrivalTimeSlot => arrivalTimeSlot.id === timeSlotToDelete.id),
              1,
            );
          })
          .catch(() => {
            alert('Brisanje neuspješno. Nevaljan unos ili zabranjen pristup.');
          });
      }
    },
  },
};
</script>

<style scoped>
#arrival-time-slot-manage {
  color: white;
}

.arrival-time-slot-table {
  width: 100%;
  text-align: center;
}
</style>
